import React, { useState, useEffect, useRef, useCallback  } from 'react';
import { Carousel} from 'react-bootstrap';
import './body.css'
import { Link } from 'react-router-dom';
import { Router } from 'react-router-dom';

import img1 from '../../assets/banner1.jpg';
import img2 from '../../assets/banner2.jpg';
import img3 from '../../assets/banner3.jpg';
import img4 from '../../assets/banner4.jpg';

import whoweare_img from '../../assets/whoweare_img.png';

import { motion } from 'framer-motion';


const Body = () => {
  const [currentStep, setCurrentStep] = useState(1); // Start at step 1



// tour cost calculation states
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [kilometers, setKilometers] = useState(100);
  const [cost, setCost] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const sliderRef = useRef(null);

  const vehicles = [
    {
      id: 1,
      name: "Car (Sedan / Med)",
      models: "Toyota Prius, Toyota Axio, Toyota Corolla, Honda Grace, Suzuki Swift, Suzuki Swift Dzire, Nissan Sunny",
      capacity: "1-4 passengers, 2-3 medium bags",
      comfort: "A/C, good for city tours, airport transfers, and long-distance trips",
      pricePerKm: 130,
      usdPrice: 0.40
    },
    {
      id: 2,
      name: "Car (Small/Flex)",
      models: "Panda, Selaran, Toyota Vitz, Suzuki Alto/Wagon R, Toyota Aqua, Nissan March, Perodua Axia",
      capacity: "1-3 passengers, 1-2 medium bags",
      comfort: "Economical option for small groups",
      pricePerKm: 100,
      usdPrice: 0.33
    },
    {
      id: 3,
      name: "Van (Mini Van / Family Van)",
      models: "Toyota KDH (Hiace), Toyota Noah, Toyota Voxy, Nissan Serena, Toyota KDH 200/201, Nissan Caravan, KDH Flat Roof",
      capacity: "5-6 passengers",
      comfort: "Ideal for family trips",
      pricePerKm: 150,
      usdPrice: 0.50
    },
    {
      id: 4,
      name: "Large Van",
      models: "Toyota Coaster, Nissan Civilian, KDH High Roof, Dolfing",
      capacity: "8-9 passengers",
      comfort: "Great for larger groups",
      pricePerKm: 175,
      usdPrice: 0.58
    },
    {
      id: 5,
      name: "SUV",
      models: "Chevrolet Captiva, Hyundai Santa Fe, KIA Sorento, Nissan X-Trail, Hyundai Tucson, Honda CR-V, Honda Vezel",
      capacity: "5-7 passengers",
      comfort: "Comfortable for all terrains",
      pricePerKm: 190,
      usdPrice: 0.63
    },
    {
      id: 6,
      name: "Full-Size Bus",
      models: "Yutong, Mitsubishi Rosa (large size)",
      capacity: "25-40 passengers",
      comfort: "For large groups and tours",
      pricePerKm: 270,
      usdPrice: 0.90
    }
  ];

  useEffect(() => {
    if (selectedVehicle) {
      const calculatedCost = kilometers * selectedVehicle.pricePerKm;
      setCost(calculatedCost);
    }
  }, [selectedVehicle, kilometers]);

  const handleSliderInteraction = useCallback((clientX) => {
    const slider = sliderRef.current;
    if (!slider) return;
    
    const rect = slider.getBoundingClientRect();
    const offsetX = clientX - rect.left;
    const percentage = Math.max(0, Math.min(1, offsetX / rect.width));
    setKilometers(Math.round(percentage * 1000));
  }, []);

  // Mouse event handlers
  const handleMouseClick = useCallback((e) => {
    handleSliderInteraction(e.clientX);
  }, [handleSliderInteraction]);

  const handleMouseDrag = useCallback((e) => {
    if (isDragging) {
      handleSliderInteraction(e.clientX);
    }
  }, [isDragging, handleSliderInteraction]);

  const startMouseDrag = useCallback((e) => {
    setIsDragging(true);
    handleSliderInteraction(e.clientX);
  }, [handleSliderInteraction]);

  // Touch event handlers
  const handleTouchClick = useCallback((e) => {
    e.preventDefault();
    handleSliderInteraction(e.touches[0].clientX);
  }, [handleSliderInteraction]);

  const handleTouchDrag = useCallback((e) => {
    if (isDragging) {
      e.preventDefault();
      handleSliderInteraction(e.touches[0].clientX);
    }
  }, [isDragging, handleSliderInteraction]);

  const startTouchDrag = useCallback((e) => {
    setIsDragging(true);
    handleSliderInteraction(e.touches[0].clientX);
  }, [handleSliderInteraction]);

  const endDrag = useCallback(() => {
    setIsDragging(false);
  }, []);

  // Update the event listeners
  useEffect(() => {
    window.addEventListener('mousemove', handleMouseDrag);
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('touchmove', handleTouchDrag, { passive: false });
    window.addEventListener('touchend', endDrag);
    
    return () => {
      window.removeEventListener('mousemove', handleMouseDrag);
      window.removeEventListener('mouseup', endDrag);
      window.removeEventListener('touchmove', handleTouchDrag);
      window.removeEventListener('touchend', endDrag);
    };
  }, [handleMouseDrag, handleTouchDrag, endDrag]);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-LK', {
      style: 'currency',
      currency: 'LKR'
    }).format(amount);
  };

  const formatUSD = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(amount);
  };









  const steps = [
    { id: 1, label: 'Enter Ride Details' },
    { id: 2, label: 'Choose a Vehicle' },
    { id: 3, label: 'Enter Contact Details' },
    { id: 4, label: 'Booking Summary' },
  ];

  const handleStepClick = (stepId) => {
      setCurrentStep(stepId);
  }








    const places = [
    {
      id: 1,
      title: "Sigiriya Rock Fortress",
      description: "Ancient rock fortress with stunning frescoes and panoramic views. A UNESCO World Heritage site dating back to the 5th century.",
      image: "sigiriya.jpg"
    },
    {
      id: 2,
      title: "Galle Fort",
      description: "Historic fortified city built by the Portuguese in the 16th century. Features colonial architecture and scenic ocean views.",
      image: "gallefort.jpg"
    },
    {
      id: 3,
      title: "Ella Rock",
      description: "Breathtaking mountain views and scenic train rides through tea plantations. Perfect for hiking enthusiasts.",
      image: "ellarock.jpg"
    },
    {
      id: 4,
      title: "Yala National Park",
      description: "Premier wildlife sanctuary famous for leopards and diverse ecosystems. Best for safari adventures.",
      image: "yala.jpg"
    },
    {
      id: 5,
      title: "Adam's Peak",
      description: "Sacred mountain with a footprint-shaped mark revered by multiple religions. Famous for sunrise hikes.",
      image: "adamspeak.jpg"
    },
    {
      id: 6,
      title: "Mirissa Beach",
      description: "Tropical paradise known for whale watching and golden sandy beaches. Ideal for relaxation and water sports.",
      image: "mirissa.jpg"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };




  return (
    <div className="py-0 mt-0 link-color">
            {/* Auto Sliding Banner */}
            <Carousel className="mb-5">
              <Carousel.Item>
                <img
                  className="d-block w-100 "
                  src={img1}
                  alt="First slide"
                />
                {/* <Carousel.Caption>
                  <h3>Welcome to Eye Care Institute</h3>
                  <p>Your vision, our mission.</p>
                </Carousel.Caption> */}
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={img2}
                  alt="Second slide"
                />
                {/* <Carousel.Caption>
                  <h3>World-Class Optometry Education</h3>
                  <p>Learn from the best in the field.</p>
                </Carousel.Caption> */}
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={img3}
                  alt="Third slide"
                />
                {/* <Carousel.Caption>
                  <h3>Innovative Eye Care Solutions</h3>
                  <p>Shaping the future of vision care.</p>
                </Carousel.Caption> */}
              </Carousel.Item>

              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={img4}
                  alt="Fourth slide"
                />
                {/* <Carousel.Caption>
                  <h3>Innovative Eye Care Solutions</h3>
                  <p>Shaping the future of vision care.</p>
                </Carousel.Caption> */}
              </Carousel.Item>
        
       
            </Carousel>

              <section>
              <div className='header-booking-taxi'>
              <h2>Chavo Tours</h2>
              <p>Chavo Tours is a Government-registered Taxi and In-Bound Tour Service based in Sri Lanka. We are dedicated to providing reliable, safe, and affordable taxi services, ensuring you a seamless travel experience across all regions of Sri Lanka. Whether you're visiting historic sites, beautiful beaches, or exploring the island's natural beauty, our services are designed to meet your travel needs. Chavo Tours offers a wide range of vehicles, including luxury cars, vans, and private chauffeur-driven rides, ensuring comfort and convenience throughout your journey. Reach out to Chavo Tours for your next adventure or business trip, we're here to assist you with all your travel needs and more.</p>



    <div className="tour-cost-calculation-container">
      <h2 className="heading-calculate-cost">Calculate the Estimated Cost</h2>
      <p className="subheading">Select a vehicle and adjust the distance to get an instant cost estimate</p>
      
      <div className="vehicle-selection">
        <h3>Select Your Vehicle</h3>
        <div className="vehicle-cards">
          {vehicles.map(vehicle => (
            <div 
              key={vehicle.id}
              className={`vehicle-card ${selectedVehicle?.id === vehicle.id ? 'selected' : ''}`}
              onClick={() => setSelectedVehicle(vehicle)}
            >
              <div className="vehicle-icon">
                {vehicle.name.includes('Car') && <i className="fas fa-car"></i>}
                {vehicle.name.includes('Van') && <i className="fas fa-van-shuttle"></i>}
                {vehicle.name.includes('SUV') && <i className="fas fa-truck-monster"></i>}
                {vehicle.name.includes('Bus') && <i className="fas fa-bus"></i>}
              </div>
              <h4>{vehicle.name}</h4>
              <p className="capacity">{vehicle.capacity}</p>
              <p className="price">{formatUSD(vehicle.usdPrice)}/km ({formatCurrency(vehicle.pricePerKm)}/km)</p>
            </div>
          ))}
        </div>
      </div>
      
      {selectedVehicle && (
        <div className="selected-vehicle-details">
          <h3>Selected: {selectedVehicle.name}</h3>
          <p><strong>Models:</strong> {selectedVehicle.models}</p>
          <p><strong>Capacity:</strong> {selectedVehicle.capacity}</p>
          <p><strong>Comfort:</strong> {selectedVehicle.comfort}</p>
        </div>
      )}
      
      <div className="distance-selection">
        <h3>Select Distance</h3>
        <div 
          className="slider-container"
          ref={sliderRef}
          onClick={handleMouseClick}
          onTouchStart={handleTouchClick}
        >
          <div className="slider-track">
            <div 
              className="slider-fill" 
              style={{ width: `${(kilometers / 1000) * 100}%` }}
            ></div>
            <div 
              className="slider-thumb" 
              style={{ left: `${(kilometers / 1000) * 100}%` }}
              onMouseDown={startMouseDrag}
              onTouchStart={startTouchDrag}
            ></div>
          </div>
          <div className="slider-scale">
            {[0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000].map((point) => (
              <div key={point} className="scale-point">
                <div className="scale-tick"></div>
                <span>{point}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="distance-display">
          <span className="distance-value">{kilometers} km</span>
        </div>
      </div>
      
      {selectedVehicle && (
        <div className="cost-calculation">
          <h3>Estimated Cost</h3>
          <div className="cost-breakdown">
            <p>{kilometers} km × {formatCurrency(selectedVehicle.pricePerKm)}/km</p>
            <h2 className="total-cost">{formatCurrency(cost)}</h2>
            <p className="usd-equivalent">({formatUSD(kilometers * selectedVehicle.usdPrice)})</p>
          </div>
        </div>
      )}
    </div>






              <h3 className='needtaxi-header'>Need a Vehicle ?  <Link to = "/booking"><button className='book-now-taxi'>Book Now !<span class="shine"></span></button></Link></h3>
             
              </div>
              </section>



               {/* Unique Features Section */}
          <div className="container mb-5 text-center custom-unique">
            <h2 className="section-title">Unique Features of Our Taxi Services</h2>
            <p className="section-description">Experience the difference with Chavo Tours:</p>
            <div className="row">
              <div className="col-md-3 feature-card">
                <div className="feature-item">
                  <i className="fas fa-car fa-3x mb-3 feature-icon"></i>
                  <h4 className="feature-title">Modern Fleet</h4>
                  <p className="feature-description">Travel in comfort and style with our well-maintained vehicles.</p>
                </div>
              </div>
              <div className="col-md-3 feature-card">
                <div className="feature-item">
                  <i className="fas fa-user-tie fa-3x mb-3 feature-icon"></i>
                  <h4 className="feature-title">Professional Drivers</h4>
                  <p className="feature-description">Driven by experts committed to safety and punctuality.</p>
                </div>
              </div>
              <div className="col-md-3 feature-card">
                <div className="feature-item">
                  <i className="fas fa-map-marker-alt fa-3x mb-3 feature-icon"></i>
                  <h4 className="feature-title">Wide Coverage</h4>
                  <p className="feature-description">Serving multiple destinations across Sri Lanka.</p>
                </div>
              </div>
              <div className="col-md-3 feature-card">
                <div className="feature-item">
                  <i className="fas fa-clock fa-3x mb-3 feature-icon"></i>
                  <h4 className="feature-title">24/7 Availability</h4>
                  <p className="feature-description">Always ready to take you where you need to go, anytime.</p>
                </div>
              </div>
            </div>
          </div>


                <div className="container mb-5">
                  <div className="row align-items-center">
                  <div className="col-md-6 custom-para">
                    <h2>Who We Are</h2>
                    <p>
                      At Chavo Tours, we are proud to be your trusted partner in providing premium taxi services. With a commitment to excellence, we ensure every journey is comfortable, reliable, and tailored to meet your needs.
                    </p>
                    
                    <p>
                      Chavo Tours stands out as a leader in Sri Lanka's transportation industry. Our network spans a wide range of locations, offering easy accessibility for both short-distance and long-distance travel. Whether you're heading to the airport, exploring the city, or embarking on a road trip, we've got you covered.
                    </p>
                    
                    <p>
                      Our mission is to deliver world-class transportation services that prioritize safety, punctuality, and customer satisfaction. Every ride with Chavo Tours is backed by professionally trained drivers, well-maintained vehicles, and a seamless booking experience designed to make travel stress-free.
                    </p>
                    
                    <p>
                      We take pride in offering diverse travel options, from solo rides to group transport, ensuring that we cater to all customer requirements. With a focus on sustainable practices and continuous innovation, Chavo Tours is more than just a taxi service, it's a commitment to exceptional journeys.
                    </p>
                    
                    <p>
                      Experience the difference with Chavo Tours, where every trip is more than just a ride, it's a journey crafted with care and precision. Choose Chavo Tours for transportation that exceeds expectations.
                    </p>
                  </div>

                    <div className="col-md-6">
                    <img
                    src={whoweare_img}
                    alt="Who We Are"
                    className="img-fluid rounded custom-img"
                    />
                    </div>
                    <div
                        className="know-more">
                        <a href="/aboutus" className="contact-button text-decoration-none">
                          More info <span>&#x2192;</span>
                        </a>
                      </div>
                  </div>
                </div>
    



                <div className="in-between-image">
                  <img src="/middlebanner.png" alt="Description of image" />
                </div>






        <div className="tour-service-container">
          <motion.div 
            className="best-place-visit"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="best-place-visit-heading">Best Places to Visit in Sri Lanka</h1>
            <p className="subheading">Explore the wonders of the pearl of the Indian Ocean</p>
          </motion.div>

          <motion.div 
            className="places-container"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {places.map((place, index) => (
              <motion.div 
                key={place.id}
                className={`place-card ${index % 2 === 0 ? 'left' : 'right'}`}
                variants={itemVariants}
                whileHover={{ scale: 1.03 }}
              >
                <div className="place-content">
                  {index % 2 === 0 ? (
                    <>
                      <div className="text-content">
                        <h2>{place.title}</h2>
                        <p>{place.description}</p>
                        <Link to="/booking">
                          <button className="tour-button">Book Tour</button>
                        </Link>
                      </div>
                      <div className="image-container">
                        <img src={`${process.env.PUBLIC_URL}/${place.image}`} alt={place.title} />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="image-container">
                        <img src={`${process.env.PUBLIC_URL}/${place.image}`} alt={place.title} />
                      </div>
                      <div className="text-content">
                        <h2>{place.title}</h2>
                        <p>{place.description}</p>
                        <Link to="/booking">
                          <button className="tour-button">Book Tour</button>
                        </Link>
                      </div>
                    </>
                  )}
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>


<div class="tripadvisor-section">
  <div class="tripadvisor-widget">
    <div class="tripadvisor-container" aria-label="TripAdvisor review widget">
      <div id="TA_cdswritereviewlg240" class="TA_cdswritereviewlg">
        <ul id="EcOVIF0KXjgb" class="TA_links LQdPUqgeM7">
          <li id="NYpdtI5r0" class="W5J9n4Lb95">
            <a target="_blank" rel="noopener noreferrer" 
              href="https://www.tripadvisor.com/Attraction_Review-g2645552-d33416695-Reviews-Chavo_Tours-Wellawaya_Uva_Province.html" 
              aria-label="Open TripAdvisor review page (opens in new tab)">
              <img 
                src="https://static.tacdn.com/img2/brand_refresh/Tripadvisor_lockup_horizontal_secondary_registered.svg" 
                alt="TripAdvisor"
              />
            </a>
          </li>
        </ul>
      </div>
      <script async 
        src="https://www.jscache.com/wejs?wtype=cdswritereviewlg&amp;uniq=240&amp;locationId=33416695&amp;lang=en_US&amp;display_version=2" 
        data-loadtrk onload="this.loadtrk=true"></script>
    </div>
  </div>

  <div class="tripadvisor-text">
    <h3>We are rated on TripAdvisor ⭐️</h3>
    <p>
      Guests love their time with Chavo Tours!  
      Drop your review and help more travelers discover unforgettable experiences.
    </p>
    <a class="review-btn" href="https://www.tripadvisor.com/Attraction_Review-g2645552-d33416695-Reviews-Chavo_Tours-Wellawaya_Uva_Province.html" target="_blank">
      Write a Review →
    </a>
  </div>
</div>





    
         {/* Customer Feedback Section */}
            <div className="container mb-5">
              <h2 className="text-center">Customer Feedback</h2>
              <Carousel className="mt-4">
                <Carousel.Item>
                  <div className="row justify-content-center">
                    <div className="col-md-3 text-center mb-4">
                      {/* <img
                        src="customer1.jpg" 
                        alt="Customer 1"
                        className="rounded-circle mb-3"
                        width="100"
                        height="100"
                      /> */}
                      <blockquote className="blockquote">
                        <p>
                          "Chavo Tours made my trip hassle-free and enjoyable. The driver was courteous, and the vehicle was spotless!"
                        </p>
                        <footer className="blockquote-footer">
                          Jane Doe <br /> Ireland
                        </footer>
                      </blockquote>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                      {/* <img
                        src="customer2.jpg" 
                        alt="Customer 2"
                        className="rounded-circle mb-3"
                        width="100"
                        height="100"
                      /> */}
                      <blockquote className="blockquote">
                        <p>
                          "Booking with Chavo Tours was the best decision! The ride was smooth, and the service exceeded my expectations."
                        </p>
                        <footer className="blockquote-footer">
                          John Smith <br /> USA
                        </footer>
                      </blockquote>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                      {/* <img
                        src="customer3.jpg" 
                        alt="Customer 3"
                        className="rounded-circle mb-3"
                        width="100"
                        height="100"
                      /> */}
                      <blockquote className="blockquote">
                        <p>
                          "I appreciate the punctuality and professionalism of Chavo Tours. Highly recommended for anyone traveling in Sri Lanka."
                        </p>
                        <footer className="blockquote-footer">
                          Priya Kumar <br /> India
                        </footer>
                      </blockquote>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                      {/* <img
                        src="customer4.jpg" 
                        alt="Customer 4"
                        className="rounded-circle mb-3"
                        width="100"
                        height="100"
                      /> */}
                      <blockquote className="blockquote">
                        <p>
                          "Chavo Tours went above and beyond! The driver even helped us with our luggage. Excellent service!"
                        </p>
                        <footer className="blockquote-footer">
                          Mohamed Ali Buckar <br /> Bangladesh 
                        </footer>
                      </blockquote>
                    </div>
                  </div>
                </Carousel.Item>

                <Carousel.Item>
                  <div className="row justify-content-center">
                    <div className="col-md-3 text-center mb-4">
                      {/* <img
                        src="customer5.jpg" 
                        alt="Customer 5"
                        className="rounded-circle mb-3"
                        width="100"
                        height="100"
                      /> */}
                      <blockquote className="blockquote">
                        <p>
                          "The ride was comfortable and affordable. I’ll definitely book with Chavo Tours again!"
                        </p>
                        <footer className="blockquote-footer">
                          Kavinda Perera <br /> Negombo
                        </footer>
                      </blockquote>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                      {/* <img
                        src="customer6.jpg"
                        alt="Customer 6"
                        className="rounded-circle mb-3"
                        width="100"
                        height="100"
                      /> */}
                      <blockquote className="blockquote">
                        <p>
                          "Exceptional service! The driver was friendly and made my journey stress-free."
                        </p>
                        <footer className="blockquote-footer">
                          Anjali Fernando <br /> Matara
                        </footer>
                      </blockquote>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                      {/* <img
                        src="customer7.jpg" 
                        alt="Customer 7"
                        className="rounded-circle mb-3"
                        width="100"
                        height="100"
                      /> */}
                      <blockquote className="blockquote">
                        <p>
                          "From booking to drop-off, everything was seamless. I highly recommend Chavo Tours!"
                        </p>
                        <footer className="blockquote-footer">
                          Harsha Jayawardena <br /> Nuwara Eliya
                        </footer>
                      </blockquote>
                    </div>
                    <div className="col-md-3 text-center mb-4">
                      {/* <img
                        src="customer8.jpg" 
                        alt="Customer 8"
                        className="rounded-circle mb-3"
                        width="100"
                        height="100"
                      /> */}
                      <blockquote className="blockquote">
                        <p>
                          "The best taxi service I’ve ever used in Sri Lanka. Prompt, professional, and friendly!"
                        </p>
                        <footer className="blockquote-footer">
                          Shalini Rajapaksha <br /> Batticaloa
                        </footer>
                      </blockquote>
                    </div>
                  </div>
                </Carousel.Item>
              </Carousel>
            </div>

  






    </div>

  );
};

export default Body;



